import thunkMiddleware from 'redux-thunk';
import { createStore, applyMiddleware, compose } from 'redux';
import rootReducer from './reducers';
import authenticationMiddleware from './middlewares/authenticationMiddleware';
import loggingMiddleware from './middlewares/loggingMiddleware';

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose; // eslint-disable-line no-underscore-dangle

export default createStore(
    rootReducer,
    composeEnhancers(
        applyMiddleware(thunkMiddleware, authenticationMiddleware, loggingMiddleware),
    ),
);
